import React, { Component } from 'react';

import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import Leadpage from '../Leadpage/Leadpage';
import Welcome from "../Welcome/Welcome"
import FakeStats from '../FakeStats/FakeStats';
import NextGame from '../NextGame/NextGame.jsx';
import HelpPack from '../HelpPack/HelpPack';
import PlayBuzz from '../PlayBuzz/PlayBuzz';
import Rules from '../Rules/Rules';
import RulesData from "../RulesData/RulesData";
import Remote from '../Remote/Remote';

import _GreenList from "../../api/GreenList.json"
import _RulesData from "../../api/RulesData.json"

class App extends Component {
  render() {
    return (
      <div className="App">
        <Header />
        <Welcome />
        {/* <NextGame /> */}
        <FakeStats />
        <HelpPack />
        <RulesData sectionName="Green_Navigation" jsonFile={_GreenList} className="greenlist" />
        <PlayBuzz />
        <Remote />
        <RulesData sectionName="Up_Navigation" jsonFile={_RulesData} className="rulesdata" />
        <Rules />
        <Leadpage />
        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/Components/App/App.jsx